
import React, { useState, useEffect } from 'react';
import Box from "@mui/material/Box";
import { Grid, Button, Tab } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from "@mui/material/styles";
import Header from "../../../components/Header";
import TextField from '@mui/material/TextField';
import { boxStyle } from "../../../theme";
import { ReactNotifications } from "react-notifications-component";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import HistoryIcon from '@mui/icons-material/History';
import API from "../../../api";
import TicketHistory from "./ticketsHystory/TicketHistory"
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ReturnTickets from './returnTickets';
import { startToast, updateToastSuccess, updateToastError } from '../../../utils/notification-loading';


const StyledText = styled(TextField)`
  background-color: rgba(103, 103, 103, 0.361);

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #459296; // Change to your desired focus color
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Change to your desired label focus color
  }
`;

const Ticket = () => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [charCount, setCharCount] = useState(0); // Stato per il conteggio dei caratteri
    const [history, setHistory] = useState(false);
    const [tabValue, setTabValue] = useState("1");
    const [, setLecss] = useState([])


    useEffect(() => {
        API.get_lecs().then(res => {
            let lecsArray = []
            res.data.devices.forEach(item => {
                lecsArray.push(item.matricola)
            })
            setLecss(lecsArray)
        })
    }, [])

    const handleSubmit = (event) => {
        startToast()
        event.preventDefault();
        API.postCreateTicket({
            'object': subject,
            'message': message
        }).then((result) => {
            if (result.data === 'Ticket inviato') {
                updateToastSuccess("Message sent correctly");
                setSubject('');
                setMessage('');
                setCharCount(0); // Reimposta il conteggio dei caratteri a 0
            } else {
                updateToastError("Error sending message, Retry");
            }
        });
    };

    // Funzione per conteggiare i caratteri nel campo "Message"
    const countChars = (text) => {
        return text.length;
    };
    const handleHistory = () => {
        if (history)
            setHistory(false);
        else
            setHistory(true);
    }

    // Gestisce il cambiamento del testo nel TextField e aggiorna il conteggio dei caratteri
    const handleTextChange = (e) => {
        const newText = e.target.value;
        setMessage(newText);
        setCharCount(countChars(newText)); // Aggiorna il conteggio dei caratteri
    };

    const TOChangeTab = (event, newValue) => {
        setTabValue(newValue)
    }

    return (
        <Box m="20px">
            <ReactNotifications />

            {/* HEADER */}
            <Header title="TICKET" subtitle="Send your feedback" />



            <TabContext value={tabValue}  >
                <Box sx={{
                    borderBottom: 1, 
                    borderColor: 'divider',
                    }}>
                    <TabList onChange={TOChangeTab} aria-label='Tickets Mode'
                        sx={{
                            backgroundColor: '#1E1E1E',
                            display: 'flex',
                            width: 'max-content',
                            borderRadius: 1,
                            "& .MuiTabs-indicator": {
                                backgroundColor: '#459296'
                            }
                        }}>
                        <Tab className="tabIp" sx={{
                            color: 'white',
                            fontWeight: 900,
                        }} label="Support Tickets" value="1" />
                        <Tab className="tabIp" sx={{
                            color: 'white',
                            fontWeight: 900,
                        }} label="Return Tickets" value="2" />
                    </TabList>
                    <TabPanel value='1'>
                        <Box sx={[boxStyle, {p:2}]}>


                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={2} >

                                        {/* Subject Input */}
                                        <Grid size={7}>
                                            <StyledText
                                                id="outlined-basic"
                                                label="Subject"
                                                variant="outlined"
                                                value={subject}
                                                onChange={(e) => setSubject(e.target.value)}
                                                fullWidth
                                                inputProps={{ maxLength: 100 }}
                                            />
                                        </Grid>

                                        {/* Message Input */}
                                        <Grid size={12}>
                                            <StyledText
                                                id="outlined-multiline-static"
                                                label="Message"
                                                multiline
                                                fullWidth
                                                value={message}
                                                onChange={handleTextChange}
                                                rows={13}
                                                slotProps={{
                                                    input: {
                                                        maxLength: 500,
                                                        endAdornment: (
                                                            <Box position="absolute" right={0} bottom={0} padding={2}>
                                                                {charCount}/500
                                                            </Box>
                                                        ),
                                                    }
                                                 }}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        {/* Buttons */}
                                        <Grid size={12} container justifyContent="flex-end" spacing={2}>
                                            <Grid >
                                                <Button
                                                    className='ticketHistory'
                                                    variant="contained"
                                                    onClick={handleHistory}
                                                    sx={{
                                                        backgroundColor: "#2d2d2d !important",
                                                        mt: 3,
                                                        mb: 2,
                                                        "&:hover": {
                                                            backgroundColor: "#eaeaea !important",
                                                            color: "#131C2D",
                                                        },
                                                    }}
                                                >
                                                    <HistoryIcon />
                                                    <Typography>Tickets History</Typography>
                                                </Button>
                                            </Grid>
                                            <Grid >
                                                <Button
                                                    variant="contained"
                                                    type='submit'
                                                    sx={{
                                                        backgroundColor: "#2d2d2d !important",
                                                        mt: 3,
                                                        mb: 2,
                                                        "&:hover": {
                                                            backgroundColor: "#eaeaea !important",
                                                            color: "#131C2D",
                                                        },
                                                    }}
                                                >
                                                    <ForwardToInboxIcon />
                                                    <Typography>SEND MESSAGE</Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Box>
                        {history && <Box width='70%' height='50vh' marginTop={3}><TicketHistory /></Box>}
                    </TabPanel>
                    <TabPanel value='2'>
                        <ReturnTickets />
                    </TabPanel>
                </Box>
            </TabContext>

        </Box>
    );
}

export default Ticket;